import React from 'react';
import { Row, Col } from 'antd';
import mapValues from 'lodash/mapValues'

export const Flex = (props: any) => {
    const {
        span = [], xs = [], sm = [], md = [], lg = [], xl = [],
        gutter = [20, 20],
        children
    } = props
    const co = {span, xs, sm, md, lg, xl}
    const values: any = {span: [], xs: [], sm: [], md: [], lg: [], xl: []}
    return <Row  gutter={gutter} >
        {React.Children.map(children, (child, i) => {
            const props = mapValues(co, (value, key) => {
                if(value[i]) {
                    values[key].push(value[i])
                    return value[i]
                } else {
                    const len = values[key].length
                    return values[key][i%len]
                }
                
            })
            return (
                <Col {...props} >
                    {child}
                </Col>
            )
        })}
    </Row>
}

